// extracted by mini-css-extract-plugin
export var modal = "_gg-0";